import { TERMS_AND_CONDITIONS } from "../../../../../../routes";
import normalizeDate from "../../../../../../utility/normalizeDate";
import DatePicker from "react-datepicker";

const SelfDeclaration = ({ setFormState, formState, editMode, isLoading }) => {
    
    return (
        <>
            <div className="card p-4 border-1 mt-3">
                <h5>Self Declaration</h5>
                <p className="text-black-50 m-0">
                    You are about to declare that you have met requirements under the Property & Stock Agents Act 2002.
                    This declaration will be used to demonstrate compliance and may be subject to audit review by Fair
                    Trading
                </p>
            </div>

            <div className="w-100 m-0 p-0 mt-3" style={{ maxWidth: "60rem" }}>
                <div className="row p-0 m-0">
                    <div className="col-lg-8 p-0 d-flex align-items-center">
                        <div style={{ flex: "1 0 50%" }}>
                            <label htmlFor="nameOfPersonCompletingForm" className="d-block form-label m-0 text-nowrap">
                                Name of person completing form:
                            </label>
                        </div>
                        <div style={{ flex: "1 0 50%" }}>
                            <input
                                value={formState.nameOfPersonCompletingForm}
                                onChange={(e) =>
                                    setFormState({
                                        ...formState,
                                        nameOfPersonCompletingForm: e.target.value,
                                    })
                                }
                                type="text"
                                className="form-control w-100"
                                id="nameOfPersonCompletingForm"
                            />
                        </div>
                    </div>

                    <div className="col-lg-4 p-0 mt-3 mt-lg-0 d-flex align-items-center">
                        <div style={{ flex: "1 0 50%" }}>
                            <label htmlFor="dateOfFormCompletion" className="form-label w-100 m-0 pe-lg-3 text-lg-end">
                                Date :
                            </label>
                        </div>
                        
                        <div className="position-relative" style={{ flex: "1 0 50%" }}>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={
                                    (formState.dateOfFormCompletionInMilliSeconds?.toString() !== "0" && !isNaN(new Date(parseInt(formState.dateOfFormCompletionInMilliSeconds)).getTime()))
                                    ? new Date(parseInt(formState.dateOfFormCompletionInMilliSeconds))
                                    : null 
                                }
                                placeholderText="Enter Date"
                                onChange={(date) => setFormState((fs) => ({
                                    ...fs,
                                    dateOfFormCompletionInString: normalizeDate(date?.getTime()) || "",
                                    dateOfFormCompletionInMilliSeconds: date?.getTime() || 0,
                                }))}
                            />
                            <div className="datepicker-icon"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-center mt-3">
                <input
                    checked={formState.tncAgreed}
                    onChange={(e) => setFormState((fd) => ({ ...fd, tncAgreed: e.target.checked }))}
                    type="checkbox"
                    className="form-check-input"
                    id="tncAgree"
                />
                <label className="form-check-label ms-2" htmlFor="tncAgree">
                    I agree to the <a className="ms-2" target="_blank" href={TERMS_AND_CONDITIONS}>Terms and services</a>
                </label>
            </div>

            <div className="d-flex justify-content-center mt-3">
                {isLoading ? (
                    <button className="d-flex align-items-center btn btn-primary text-light" disabled={true}>
                        {editMode ? "Updating" : "Submiting"}
                        <div className="spinner-border spinner-border-sm ms-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </button>
                ) : (
                    <button className="btn btn-primary text-light">{editMode ? "Update" : "Submit"}</button>
                )}
            </div>
        </>
    );
};

export default SelfDeclaration;
